/**
 * A JWT's `exp`, in ms, or undefined when the token is not a JWT with one.
 *
 * Read without verifying the signature, which is fine for what it is used for:
 * deciding when to move to a new connection. It grants nothing - the backend
 * takes the expiry from the token it verified when minting the ticket.
 */
export const readJwtExpiry = (token: string): number | undefined => {
  const payload = token.split(".")[1];
  if (!payload) return undefined;
  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const { exp } = JSON.parse(window.atob(padded));
    return typeof exp === "number" && Number.isFinite(exp)
      ? exp * 1000
      : undefined;
  } catch (e) {
    return undefined;
  }
};
